/**
 * Seed.Page
 */

define(
        'Seed.Page',['jquery', 'parameter', 'resizeScreen', 'Seed'],
        function ($, parameter, resizeScreen, Seed) {
            'use strict';

            Seed.Page = {
                Load: function (Page, pImport, newTab) {

                    var sImport = "";
                    if (pImport) {
                        var length = pImport.length;
                        for (var i = 0; i < length; i++) {
                            pImport[i][1] = parameter.decodeParam(pImport[i][1]);
                            sImport += "&" + pImport[i][0] + "=" + pImport[i][1];
                        }
                    }

                    Seed.Ajax.Post({
                        url: Page,
                        data: sImport,
                        json: true,
                        async: false,
                        success: function (xml) {
                            if (newTab) {
                                // var pTarget = Seed.Tab.GetFrame();
                                Seed.Tab.GetFrame().html(xml.html);

                                var jscript = document.createElement("SCRIPT");
                                jscript.text = xml.script;
                                Seed.Tab.GetFrame().append(jscript);

                                resizeScreen.resizeScreen();
                            }

                            $('#bench').html(xml.bench);
                        }
                    });
                }
            };
        }
);

